import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { InputCalendarioComponent } from './input-calendario.component';
import { BrMaskerModule } from 'br-mask';
import { CalendarioComponentModule } from '../calendario/calendario.component.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MonthPickerModule } from '../month-picker/month-picker.module';

@NgModule({
  declarations: [
    InputCalendarioComponent
  ],
  imports: [
    IonicModule,
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    BrMaskerModule,
    CalendarioComponentModule,
    MonthPickerModule
  ],
  exports: [
    InputCalendarioComponent
  ],
  entryComponents: [
    InputCalendarioComponent
  ]
})
export class InputCalendarioComponentModule { }
